import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface SectionCardProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  /** 헤더 우측 액션. */
  actions?: React.ReactNode;
  /** 본문 패딩 제거(테이블 등 edge-to-edge). */
  flush?: boolean;
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

/** 섹션 카드 — Admin Kit Card(헤더: 제목·설명·우측 액션 / 본문). 대시보드 위젯·상세 섹션·목록 컨테이너 공용. */
export function SectionCard({
  title,
  description,
  actions,
  flush,
  className,
  contentClassName,
  children,
}: SectionCardProps) {
  const hasHeader = Boolean(title || actions);
  return (
    <Card className={className}>
      {hasHeader && (
        <CardHeader className="flex flex-row items-start justify-between gap-4 space-y-0">
          <div className="min-w-0 space-y-1.5">
            {title && <CardTitle>{title}</CardTitle>}
            {description && <CardDescription>{description}</CardDescription>}
          </div>
          {actions && <div className="flex flex-none items-center gap-2">{actions}</div>}
        </CardHeader>
      )}
      <CardContent className={cn(!hasHeader && 'pt-6', flush && 'px-0 pb-0', contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
}
